import {useQuery} from '@tanstack/react-query'
import {useAccessToken} from '@salesforce/commerce-sdk-react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {useAppOrigin} from '@salesforce/retail-react-app/app/hooks/use-app-origin'
import {doCustomAPICall} from '../utils/custom-api-utils'

const onClient = typeof window !== 'undefined'

export const useMergeWishList = (isRegistered, customerNumber) => {
    const {getTokenWhenReady} = useAccessToken()
    const config = getConfig()
    const appOrigin = useAppOrigin()
    const customAPIFolderName = 'merge-wishlist'

    const getApiPath = () => {
        if (!onClient) return null

        const guestItems = JSON.parse(localStorage.getItem('guestWishlistItems')) || []

        if (!guestItems || guestItems.length === 0) return null

        const guestWishlistObj = guestItems.reduce((map, item) => {
            if (!map.has(item?.productId || item?.id)) {
                map.set(item?.productId || item?.id, item?.quantity || 1)
            }
            return map
        }, new Map())

        const guestWishlistProducts = JSON.stringify(Object.fromEntries(guestWishlistObj))

        return `mergeWishlist?c_wishlist=${guestWishlistProducts}&c_customerNo=${customerNumber}&`
    }

    const apiPath = getApiPath()
    const shouldFetch = Boolean(isRegistered && customerNumber && apiPath)

    const query = useQuery({
        queryKey: ['custom', 'merge-wishlist', customerNumber],
        queryFn: async () => {
            const data = await doCustomAPICall(getTokenWhenReady, {
                config,
                appOrigin,
                customAPIFolderName,
                apiPath,
                reqParams: {method: 'POST'}
            })
            return data
        },
        enabled: shouldFetch,
        staleTime: 0,
        cacheTime: 0
    })

    return {data: query.data}
}
